"use strict";
function calculateProcessingProgress(files) {
    var values = [];
    var mode;
    var message;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(files)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var progress = _step.value.progress;
            var preprocess = progress.preprocess, postprocess = progress.postprocess; // In the future we should probably do this differently. For now we'll take the
            // mode and message from the first file…
            if (message == null && (preprocess || postprocess)) {
                var ref;
                ref = preprocess || postprocess, mode = ref.mode, message = ref.message, ref;
            }
            if ((preprocess == null ? void 0 : preprocess.mode) === 'determinate') values.push(preprocess.value);
            if ((postprocess == null ? void 0 : postprocess.mode) === 'determinate') values.push(postprocess.value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var value = values.reduce(function(total, progressValue) {
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}
module.exports = calculateProcessingProgress;
